import type { ReactNode } from 'react'
import classes from './tab-panel.module.css'

interface Props {
  children?: ReactNode
  id: string
  value: string
}

export function TabPanel(props: Props) {
  const { children, value, id } = props

  return (
    <div className={classes.root} data-id="tidal-sandbox-tab-panel" hidden={value !== id} role="tabpanel">
      {children}
    </div>
  )
}
